class LazyVideo extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    // Get the data-lazy-video-id attribute from this lazy-video element
    this.lazyVideoId = this.getAttribute('data-lazy-video-id')

    // Reference to the video element within this lazy-video instance
    this.video = window.BAO.Utils.getElement('video', { context: this })

    // Reference to the video controls container
    if (
      this.els.videoSoundToggleContainer &&
      this.els.videoSoundToggleContainer.selector
    ) {
      this.videoControlsContainer = this.querySelector(
        `[data-lazy-video-id="${this.lazyVideoId}"] ${this.els.videoSoundToggleContainer.selector}`,
      )
    }

    // Initialize IntersectionObserver
    this.observer = new IntersectionObserver(this.onEntry.bind(this), {
      threshold: 0,
    })

    this.observer.observe(this.video)
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleOverlayClick = this.handleOverlayClick.bind(this)

    // Sound mute/unmute trigger
    if (this.els.videoSoundToggle && this.els.videoSoundToggle.selector) {
      this.els.videoSoundToggle.elements.forEach((triggerEl) => {
        triggerEl.addEventListener('click', this.handleTrigger)
      })
    }

    if (this.externalEls.contentOverlay?.exists) {
      const overlayEls = this.externalEls.container?.element.querySelectorAll(
        `${this.externalEls.contentOverlay.selector}, [data-lazy-video-id="${this.lazyVideoId}"] [data-lazy-video-el="desktopOverlay"], [data-lazy-video-id="${this.lazyVideoId}"] [data-lazy-video-el="mobileOverlay"]`,
      )

      overlayEls.forEach((overlayEl) => {
        overlayEl.addEventListener('click', this.handleOverlayClick)
      })
    }
  }

  handleOverlayClick () {
    this.hideAllOverlays()
    this.playVideo()
  }

  hideAllOverlays () {
    const overlaySelectors = [
      `${this.externalEls.contentOverlay.selector}`,
      `[data-lazy-video-id="${this.lazyVideoId}"] [data-lazy-video-el="desktopOverlay"]`,
      `[data-lazy-video-id="${this.lazyVideoId}"] [data-lazy-video-el="mobileOverlay"]`,
    ]

    overlaySelectors.forEach((selector) => {
      const overlays =
        this.externalEls.container?.element.querySelectorAll(selector)

      overlays.forEach((overlay) => {
        if (overlay.dataset.hideContentOnClick === 'false') {
          return
        }

        overlay.style.visibility = 'hidden'
      })
    })
  }

  playVideo () {
    if (this.video.paused) {
      this.video.play()
    }

    // Show the video controls when the video starts playing
    if (this.videoControlsContainer) {
      this.videoControlsContainer.setAttribute('aria-hidden', 'false')
    }
  }

  handleTrigger (event) {
    const button = event.currentTarget

    // Find the sound icons within the button
    const soundOffIcon = button.querySelector(
      `${this.els.soundToggleOff.selector}`,
    )
    const soundOnIcon = button.querySelector(
      `${this.els.soundToggleOn.selector}`,
    )

    // Toggle the muted state of the video
    if (this.video.muted) {
      this.video.muted = false
      soundOffIcon?.setAttribute('aria-hidden', 'true')
      soundOnIcon?.setAttribute('aria-hidden', 'false')
    } else {
      this.video.muted = true
      soundOffIcon?.setAttribute('aria-hidden', 'false')
      soundOnIcon?.setAttribute('aria-hidden', 'true')
    }
  }

  onEntry ([entry], observer) {
    if (!entry.isIntersecting) return

    if (this.video.dataset?.poster) {
      this.video.setAttribute('poster', this.video.dataset.poster)
    }

    // Load video sources
    Array.from(this.video.children).forEach((videoSource) => {
      if (videoSource.tagName === 'SOURCE') {
        videoSource.src = videoSource.dataset.src
      }
    })

    this.video.load()
    observer.unobserve(this.video)
    this.setAttribute('loaded', '')

    if (
      window.BAO.MediaBreakpoints.isSm ||
      !this.video.hasAttribute('autoplay')
    ) {
      return
    }

    if (this.video.paused) {
      document.addEventListener('touchstart', () => {
        if (this.video.paused) {
          this.video.play()
        }
      })
    }
  }
}

if (!customElements.get('lazy-video')) {
  customElements.define('lazy-video', LazyVideo)
}
